import React from "react";
import { Input, Checkbox } from "antd";
import { SiTiktok, SiInstagram } from "react-icons/si";

const WelcomeStep4 = ({ instagram, setInstagram, tiktok, setTiktok }) => {
  return (
    <div className="welcome-modal-content">
      <div className="header-modal">
        Où pouvons-nous vous suivre ?{" "}
        <span role="img" aria-label="emoji">
          🏄‍♂️
        </span>{" "}
      </div>
      <div className="content-welcome-modal">
        <div className="form-new-page">
          <div>Renseignez votre profil Instagram et/ou Tiktok :</div>
          <div className="container-social-welcome">
            <div className="script-type">
              <div className="third-title social">
                {" "}
                <Checkbox
                  onChange={() => {
                    setInstagram({ ...instagram, display: !instagram.display });
                  }}
                  checked={instagram.display}
                />
                <div className="name">
                  <SiInstagram style={{ marginRight: "10px" }} />
                  Instagram
                </div>
              </div>
              {instagram.display ? (
                <div className="script-input">
                  <Input
                    defaultValue={instagram.url}
                    onChange={(e) => {
                      setInstagram({
                        ...instagram,
                        url: e.target.value.trim(),
                      });
                    }}
                    placeholder="Nom d'utilisateur Instagram"
                    maxLength={200}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="script-type">
              <div className="third-title social">
                {" "}
                <Checkbox
                  onChange={() => {
                    setTiktok({ ...tiktok, display: !tiktok.display });
                  }}
                  checked={tiktok.display}
                />
                <div className="name">
                  <SiTiktok style={{ marginRight: "10px" }} />
                  Tiktok
                </div>
              </div>
              {tiktok.display ? (
                <div className="script-input">
                  <Input
                    defaultValue={tiktok.url}
                    onChange={(e) => {
                      setTiktok({ ...tiktok, url: e.target.value.trim() });
                    }}
                    placeholder="Nom d'utilisateur Tiktok sans @"
                    maxLength={200}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeStep4;
